import { ChangeEmailTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ChangeEmailTrackingSchema: Record<ChangeEmailTrackingPoint, string> = {
  [ChangeEmailTrackingPoint.ChangeEmailSuccessAction]: '',
  [ChangeEmailTrackingPoint.ChangeEmailFailAction]: '',
  [ChangeEmailTrackingPoint.ChangeEmailRateLimitPopupImpression]: '',
};

export const getChangeEmailPageTypeAndSchema = (
  trackingPoint: ChangeEmailTrackingPoint
) => {
  return {
    page_type: PageType.ChangeEmailPage,
    schema: ChangeEmailTrackingSchema[trackingPoint],
  };
};
